import React from "react";

function About() {
    return (
        <section className="about-section">
            <div className="container about-layout">
            <div className="about-text">
                <h1>Little Lemon</h1>
                <h2>Chicago</h2>
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. .</p>
            </div>
            <img src="images/restauranfood1.jpg" alt="About img" className="about-image"/>
            </div>
        </section>
    )
}

export default About;